import React, { useCallback } from 'react';
import { useTheme } from '@context/themeContext';
import { ThemeSwitchIcon } from '../icons/icons/ThemeSwitchIcon';
import { IconButton } from '../buttons/IconButton/IconButton';
import './theme-setter.scss';
import { themeColors } from '@styles/theme';

export default function ThemeSetter() {
    const { theme, setTheme } = useTheme();

    const bgColor = theme === 'light' ? themeColors.grey4 : themeColors.darkGrey;
    const fontColor = theme === 'light' ? themeColors.white : themeColors.white;

    const onClick = useCallback(() => {
        setTheme(theme === 'light' ? 'dark' : 'light');
    }, [theme]);

    return (
        <div className="theme-selector">
            <IconButton
                icon={ThemeSwitchIcon}
                iconColor={fontColor}
                backgroundColor={bgColor}
                onClick={onClick}
            />
        </div>
    );
}
